module.exports = __webpack_public_path__ + "un.424ca4dfb83e20505d9c.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/1x1/un.svg
// module id = ../../../../flag-icon-css/flags/1x1/un.svg
// module chunks = styles